import React, { useState } from "react";
import OnboardingLayout from "./OnboardingLayout";
import { Grid } from "@chakra-ui/react";
import { LearningReason } from "@shared_types";
import OnboardingCard from "../Cards/OnboardingCard";

interface MotivationGoalProps {
  setGoal: (goalText: string, code: LearningReason) => void;
  startingGoal?: string;
}

type Goal = {
  emoji: string;
  text: string;
  code: LearningReason;
};

const MotivationGoal: React.FC<MotivationGoalProps> = ({
  setGoal,
  startingGoal: currentGoal,
}) => {
  const [selectedGoal, setSelectedGoal] = useState<string | null>(
    currentGoal ?? null
  );

  const goals: Goal[] = [
    { emoji: "✈️", text: "Travel", code: "travel" },
    { emoji: "💼", text: "Work", code: "work" },
    { emoji: "👯", text: "Friends & Family", code: "friends_and_family" },
    { emoji: "📚", text: "School", code: "school" },
    { emoji: "📈", text: "Self improvement", code: "self_improvement" },
    { emoji: "❤️", text: "Romance", code: "romance" },
  ];

  return (
    <OnboardingLayout
      title="Why do you want to learn Spanish?"
      subtitle="Help us tailor the experience to you."
    >
      <Grid
        templateColumns="repeat(2, 1fr)"
        gap={4}
        alignItems={"center"}
        justifyItems={"center"}
        maxW="600px"
        margin="0 auto"
      >
        {goals.map((goal, index) => (
          <OnboardingCard
            key={index}
            emoji={goal.emoji}
            title={goal.text}
            selected={selectedGoal === goal.text}
            onClick={() => {
              setGoal(goal.text, goal.code);
              setSelectedGoal(goal.text);
            }}
          />
        ))}
      </Grid>
    </OnboardingLayout>
  );
};

export default MotivationGoal;
